getSessionVariableKey = (uuid, textKey) ->
  return "mpp-edit-information-#{uuid}-#{textKey}"

removeFromStorage = (uuid, textKey) ->
  sessionStorage?.removeItem getSessionVariableKey(uuid, textKey)

getFromStorage = (uuid, textKey) ->
  sessionStorage?.getItem getSessionVariableKey(uuid, textKey)

setToStorage = (uuid, textKey, value) ->
  if sessionStorage?
    sessionStorage.setItem getSessionVariableKey(uuid, textKey), value

class EditInformation

  constructor: (@el) ->
    @rootUrl = '/merchant-page'
    @csrf = $('meta[name=csrf-token]').attr('content')
    @uuid = $('#hiddenUUID').attr('value')

    @$el = $ @el
    @$loading = @$el.find '.icon-g-loader'
    # aggregation of form elements
    @$formElements =
      name: @$el.find('.name-correction-text')
      category: @$el.find('.category-correction-text')
      address: @$el.find('.address-correction-text')
      phone: @$el.find('.phone-correction-text')
      website: @$el.find('.website-correction-text')
      additionalSuggestions: @$el.find('.suggestions')
      permanentlyClosed: @$el.find('.closed-checkbox-input')
      flagged:
        name: @$el.find('.name.section-container')
        category: @$el.find('.category.section-container')
        address: @$el.find('.address.section-container')
        phone: @$el.find('.phone.section-container')
        website: @$el.find('.website.section-container')

    @inputMaxLengths =
      name: 50,
      category: 100,
      address: 100,
      phone: 16,
      website: 200,
      additionalSuggestions: 400

    # aggregation of modal inputs
    @$inputs =
      checkboxes: @$el.find('.checkbox'),
      editInfoButton: $('.claim-your-page .edit-info-link'),
      editSectionButtons: @$el.find('.section-container'),
      formSubmitButton: @$el.find('.submit-btn'),
      hintButtons: @$el.find('.icon-question'),
      resetSectionButtons: @$el.find('.reset')

    @autofillUserInput()

    @bindEventHandlers()

  readInputValues: ->
    elementValues = {}
    for attribute, element of @$formElements
      if attribute isnt 'flagged' and attribute isnt 'permanentlyClosed'
        elementValues[attribute] = element.val()
        if not elementValues[attribute] or elementValues[attribute].length > @inputMaxLengths[attribute]
          elementValues[attribute] = null
    elementValues['permanentlyClosed'] = if @$formElements.permanentlyClosed.prop("checked") then 'CLOSED' else ''

    # Empty input values are replaced with either 'None' or null depending on whether the section was flagged or not
    # 'None' represents flagged content, while null represents the absence of a submission value entirely
    for attribute, value of elementValues
      if value is ''
        elementValues[attribute] = if @$formElements.flagged[attribute]?.hasClass('editable') then 'None' else null
    return elementValues

  autofillUserInput: ->
    corrections = JSON.parse getFromStorage(@uuid, 'corrections')
    removeFromStorage @uuid, 'corrections'
    for attribute, value of corrections
      if attribute is 'permanentlyClosed'
        if value isnt null then @$formElements[attribute]?.prop("checked", true)
      else
        if value isnt null and attribute isnt 'additionalSuggestions' then @$formElements.flagged[attribute].addClass('editable')
        if value isnt 'None' then @$formElements[attribute].val(value)

  # perform checkbox UI changes on click
  registerCheckboxes: ->
    @$inputs['checkboxes'].click (event) ->
      $container = $(event.currentTarget).parents('.closed-checkbox-container')
      $container.toggleClass('checked')

  registerEditSections: ->
    @$inputs['editSectionButtons'].click (event) ->
      $section = $ this
      if not ($section.hasClass('editable') or $section.hasClass('no-hover'))
        $section.addClass('editable')

  registerResetButtons: ->
    @$inputs['resetSectionButtons'].click (event) ->
      $section = $(event.currentTarget).parent()
      $section.removeClass('editable')

      # This prevents the containing element from toggling .editable back on
      event.stopPropagation()
      $section.find('input[type=text]').val('')

  lazyLoadImages: ->
    @$el.find('.lazy-loaded-image').each (position, imageElement) ->
      $image = $(imageElement)
      $image.attr 'src', $image.attr('lazy-load-src')

  bindEventHandlers: ->
    @$inputs['editInfoButton'].click (event) =>
      MPP.Modal.open @el
      @lazyLoadImages()

    # Register click and hover events for all modal buttons
    @registerCheckboxes()
    @registerEditSections()
    @registerResetButtons()

    @$inputs['formSubmitButton'].click => @submitForm()

  # send user submitted corrections to UGC Hivemind.
  # Users are prompted to login if they aren't already,
  # or redirected back to the page on successful submission.
  submitForm: =>
    corrections = @readInputValues()
    return unless _.compact(_.values(corrections)).length > 0

    obj =
      _csrf: @csrf,
      uuid: @uuid,
      corrections: corrections

    @$inputs['formSubmitButton'].hide()
    @$loading.show()

    $.ajax
      url: "#{@rootUrl}/edit-information"
      method: 'POST'
      data: JSON.stringify obj
      contentType: 'application/json'

      success: (res) =>
        @$loading.hide()
        @$inputs['formSubmitButton'].show()
        if MPP.JsonResponseHandler.loginRequired res
          setToStorage @uuid, 'corrections', JSON.stringify obj.corrections
          GIG.Modal.close()
          MPP.JsonResponseHandler.openModalIframeLogin()


        return unless res.result is 'ok'

        @$el.find('.thankyou-content').css('display', 'block')
        @$el.find('.edit-content').css('display', 'none')

      error: (res) ->
        #we timed out
        @$loading.hide()
        @$inputs['formSubmitButton'].show()

    true

$ -> new EditInformation('#edit-information-modal')
